import Vue from 'vue'
import VueRouter from 'vue-router'
import { Store } from 'vuex'
import { RootState } from '../store/rootState'

import pdvVendas from '../views/pdv/vendas.vue'
import pdvRelatorios from '../views/pdv/relatorios.vue'
import pdvCategorias from '../views/pdv/categorias.vue'
import pdvProdutos from '../views/pdv/produtos.vue'
import pdvEstoque from '../views/pdv/estoque.vue'
import pdvAcessoNegado from '../views/pdv/acesso-negado.vue'
import cardapioPublico from '../views/publico/cardapio.vue'
import manutencao from '../views/dashboard/manutencao.vue'
import condicaoPagamento from '../views/cadastro/condicaopagamento.vue'
import especiePagamento from '../views/cadastro/especiepagamento.vue'
import condicoesPagamentos from '../views/lista/condicoespagamentos.vue'
import especiesPagamentos from '../views/lista/especiespagamentos.vue'
import prdDashboard from '../views/prd/prdDashboard.vue'
import prdOrcamentos from '../views/prd/prdOrcamentos.vue'
import prdOrcamento from '../views/prd/prdOrcamento.vue'
import prdAnalise from '../views/prd/prdAnalise.vue'
import prdProducao from '../views/prd/prdProducao.vue'
import prdProducaoDetalhe from '../views/prd/prdProducaoDetalhe.vue'
import financeiro from '../views/financeiro.vue'
import pesquisar from '../views/pesquisar.vue'
import pesquisarItens from '../views/pesquisarItens.vue'

import funcionario from '../views/cadastro/funcionario.vue'
import cliente from '../views/cadastro/cliente.vue'
import unidade from '../views/cadastro/unidade.vue'
import niveldeacesso from '../views/cadastro/niveldeacesso.vue'
import funcionarios from '../views/lista/funcionarios.vue'
import clientes from '../views/lista/clientes.vue'
import unidades from '../views/lista/unidades.vue'
import niveisDeAcessoVue from '../views/lista/niveisdeacesso.vue'
const Sobre = () => import('../views/sobre.vue')

export function installVue2Router() {
    Vue.use(VueRouter)
}

const routes = [
	{
		path: '/cardapio',
		name: 'cardapio-publico-query',
		component: cardapioPublico,
		meta: { publico: true }
	},
	{
		path: '/cardapio/:unidade',
		name: 'cardapio-publico',
		component: cardapioPublico,
		meta: { publico: true }
	},
	{
		path: '/cardapio=:unidade',
		name: 'cardapio-publico-legado',
		component: cardapioPublico,
		meta: { publico: true }
	},
	{
		name: 'manutencao',
		path: '/manutencao',
		component: manutencao,
		meta: {
			roles: ["menu-manutencao"]
		}
	},
	{
		name: 'condicoespagamentos',
		path: '/manutencao/condicoespagamentos',
		component: condicoesPagamentos,
		meta: {
			roles: ['condicaopagamento-consultar']
		}
	},
	{
		name: 'condicaopagamento',
		path: '/manutencao/condicaopagamento/:id?',
		component: condicaoPagamento,
		meta: {
			roles: ['condicaopagamento-consultar', 'condicaopagamento-alterar']
		}
	},
	{
		name: 'especiespagamentos',
		path: '/manutencao/especiespagamentos',
		component: especiesPagamentos,
		meta: {
			roles: ['especie-pagamento-consultar']
		}
	},
	{
		name: 'especiepagamento',
		path: '/manutencao/especiepagamento/:id?',
		component: especiePagamento,
		meta: {
			roles: ['especie-pagamento-consultar', 'especie-pagamento-alterar']
		}
	},
	{
		name: 'clientes',
		path: '/manutencao/clientes',
		component: clientes,
		meta: {
			roles: ["prd-clientes-consultar"]
		}
	},
	{
		name: 'cliente',
		path: '/manutencao/cliente',
		component: cliente,
		meta: {
			roles: ["prd-clientes-alterar"]
		}
	},    
	{
		name: 'funcionarios',
		path: '/manutencao/funcionarios',
		component: funcionarios,
		meta: {
			roles: ["funcionario-consultar"]
		}
	},
	{
		name: 'funcionario',
		path: '/manutencao/funcionario',
		component: funcionario,
		meta: {
			roles: ["funcionario-alterar"]
		}
	},
	{
		name: 'unidades',
		path: '/manutencao/unidades',
		component: unidades,
		meta: {
			roles: ["unidade-consultar", "unidade-alterar"]
		}
	},
	{
		name: 'unidade',
		path: '/manutencao/unidade',
		component: unidade,
		meta: {
			roles: ["unidade-consultar", "unidade-alterar"]
		}
	},
	{
		name: 'niveisdeacesso',
		path: '/manutencao/niveisdeacesso',
		component: niveisDeAcessoVue,
		meta: {
			roles: ["Administrador"]
		}
	},  
	{
		name: 'niveldeacesso',
		path: '/manutencao/niveldeacesso',
		component: niveldeacesso,
		meta: {
			roles: ["Administrador"]
		}
	},   
	{
		name: 'niveisdeacesso',
		path: '/manutencao/niveisdeacesso',
		component: niveisDeAcessoVue,
		meta: {
			roles: ["Administrador"]
		}
	},       
	{
		path: '/',
		name: 'Sobre',
		component: Sobre,
		meta: {
			autenticado: true
		}
	},
    {
        path: '/prd',
        name: 'prd-dashboard',
        component: prdDashboard,
        meta: { roles: ['prd-dashboard-consultar'] }
    },
    {
        path: '/prd/orcamentos',
        name: 'prd-orcamentos',
        component: prdOrcamentos,
        meta: { roles: ['prd-orcamentos-consultar', 'prd-orcamentos-alterar'] }
    },
    {
        path: '/prd/orcamentos/novo',
        name: 'prd-orcamento-novo',
        component: prdOrcamento,
        meta: { roles: ['prd-orcamentos-alterar'] }
    },
    {
        path: '/prd/orcamentos/:id',
        name: 'prd-orcamento',
        component: prdOrcamento,
        meta: { roles: ['prd-orcamentos-consultar', 'prd-orcamentos-alterar', 'prd-orcamentos-controlar-cliente'] }
    },
    {
        path: '/prd/analise',
        name: 'prd-analise',
        component: prdAnalise,
        meta: { roles: ['prd-analise-consultar', 'prd-analise-alterar'] }
    },
    {
        path: '/prd/analise/:id',
        name: 'prd-analise-detalhe',
        component: prdAnalise,
        meta: { roles: ['prd-analise-consultar', 'prd-analise-alterar'] }
    },
    {
        path: '/prd/producao',
        name: 'prd-producao',
        component: prdProducao,
        meta: { roles: ['prd-pedidos-consultar', 'prd-pedidos-produzir', 'prd-pedidos-entregar'] }
    },
    {
        path: '/pesquisar',
        name: 'pesquisar',
        component: pesquisar,
        meta: { autenticado: true }
    },
    {
        path: '/pesquisar/itens',
        name: 'pesquisar-itens',
        component: pesquisarItens,
        meta: { roles: ['prd-orcamentos-consultar'] }
    },
    {
        path: '/financeiro',
        name: 'financeiro',
        component: financeiro,
        meta: { roles: ['financeiro-consultar', 'financeiro-alterar'] }
    },
    {
        path: '/prd/producao/:id',
        name: 'prd-producao-detalhe',
        component: prdProducaoDetalhe,
        meta: { roles: ['prd-pedidos-consultar', 'prd-pedidos-produzir', 'prd-pedidos-entregar'] }
    },
    { path: '/prd/pedidos', redirect: { name: 'prd-producao' } },
    { path: '/prd/pedidos/:id', redirect: to => ({ name: 'prd-producao-detalhe', params: { id: to.params.id } }) },
    {
        path: '/pdv/vendas',
        name: 'pdv-vendas',
        component: pdvVendas,
        meta: { roles: ['pdv-vendas-consultar', 'pdv-vendas-realizar'] }
    },
    {
        path: '/pdv/relatorios',
        name: 'pdv-relatorios',
        component: pdvRelatorios,
        meta: { roles: ['pdv-relatorios-consultar'] }
    },
    {
        path: '/pdv/categorias',
        name: 'pdv-categorias',
        component: pdvCategorias,
        meta: { roles: ['pdv-categorias-consultar', 'pdv-categorias-alterar'] }
    },
    {
        path: '/pdv/produtos',
        name: 'pdv-produtos',
        component: pdvProdutos,
        meta: { roles: ['pdv-produtos-consultar', 'pdv-produtos-alterar'] }
    },
    {
        path: '/pdv/estoque',
        name: 'pdv-estoque',
        component: pdvEstoque,
        meta: { roles: ['pdv-estoque-consultar', 'pdv-estoque-movimentar'] }
    },
    {
        path: '/acesso-negado',
        name: 'pdv-acesso-negado',
        component: pdvAcessoNegado,
        meta: { autenticado: true }
    },
    { path: '*', redirect: '/' }
]

export function createVue2Router(store: Store<RootState>) {
    const router = new VueRouter({
        mode: 'history',
        base: process.env.BASE_URL,
        routes,
        linkActiveClass: 'is-active'
    })

    const storeInit = store.dispatch('init')

    router.beforeEach(async (to, from, next) => {
        try {
            if (to.matched.some(record => record.meta && record.meta.publico)) {
                next()
                return
            }

            await storeInit

            if (!store.state.usuario.id) {
                next()
                return
            }

            if (to.meta && to.meta.autenticado) {
                next()
                return
            }

            const regras = store.state.usuario.regras || []
            const roles = to.matched.reduce((lista: string[], record) => lista.concat((record.meta && record.meta.roles) || []), [])
            const permitido = roles.some(role => regras.includes(role))

            if (permitido) {
                next()
                return
            }

            next({ name: 'pdv-acesso-negado' })
        } catch (error) {
            console.error(error)
            next(false)
        }
    })

    return router
}
